module.exports = __webpack_public_path__ + "static/1-asset-1-d@3x-065b28cb216a73d0877066cb8dd692b5.png";